module.exports = __webpack_public_path__ + "media/application/images/insights-img-fadab1e04548234a699293be54969ee7.png";